<div>
  <div>
    <app-toggle-input
      appConfigSettingsInput
      placeholder="OtherInsurances.TafInsurer"
      [form]="otherInsurancesFormGroup"
      [optionsList]="yesNoList"
      [control]="otherInsurancesFormGroup.get('tafInsurer')"
    ></app-toggle-input>
  </div>
  <div>
    <app-text-input
      appConfigSettingsInput
      placeholder="OtherInsurances.NameInsurer"
      [control]="otherInsurancesFormGroup.get('nameInsurer')"
      [form]="otherInsurancesFormGroup"
      showPlaceholder="false"
    ></app-text-input>
  </div>
</div>
<div>
  <div>
    <app-date-input
      appConfigSettingsInput
      placeholder="OtherInsurances.DateOfCommencement"
      [dateMask]="dateMaskFormat"
      [control]="otherInsurancesFormGroup.get('dateOfCommencement')"
      [form]="otherInsurancesFormGroup"
      datePlaceholder="CalculationInsurer.DateOfBirthPlaceholder"
    ></app-date-input>
  </div>
  <div>
    <app-text-input
      appConfigSettingsInput
      placeholder="OtherInsurances.SumAssured"
      [control]="otherInsurancesFormGroup.get('sumAssured')"
      [form]="otherInsurancesFormGroup"
      showPlaceholder="false"
      inputMask="0*.00"
      prefix="€ "
    ></app-text-input>
  </div>
</div>
<app-toggle-input
  appConfigSettingsInput
  placeholder="OtherInsurances.CancelPolicy"
  [form]="otherInsurancesFormGroup"
  [optionsList]="yesNoList"
  [control]="otherInsurancesFormGroup.get('willCancelPolicy')"
  [formSubmitted]="true"
></app-toggle-input>
<div *ngIf="willCancelPolicy">
  <app-date-input
    appConfigSettingsInput
    placeholder="PersonalDetailsInfo.DateOfCancelAOV"
    [dateMask]="dateMaskFormat"
    [control]="otherInsurancesFormGroup.get('cancellationDate')"
    [form]="otherInsurancesFormGroup"
    datePlaceholder="CalculationInsurer.DateOfBirthPlaceholder"
  ></app-date-input>
</div>
